import { useMemo, useState, useContext } from "react";

import { TableV2GridContext, ViewMode } from "../grid-store";
import { calculateActualDimensions, createContainerStyle } from "../utils";

interface UseDimensionsProps {
  hoverable: boolean;
}

export const useDimensions = ({ hoverable }: UseDimensionsProps) => {
  const gridContext = useContext(TableV2GridContext);
  const [rowHeight, setRowHeight] = useState(0);

  const { actualHeaderHeight } = useMemo(() => {
    const { actualHeaderHeight: headerHeight, actualRowHeight } = calculateActualDimensions({
      compact: gridContext?.tableStore?.viewMode === ViewMode.COMPACT,
    });
    setRowHeight(actualRowHeight);
    return { actualHeaderHeight: headerHeight };
  }, [gridContext?.tableStore?.viewMode]);

  const containerStyle = useMemo(
    () =>
      createContainerStyle({
        hoverable,
        actualHeaderHeight,
      }),
    [hoverable, actualHeaderHeight],
  );

  return {
    rowHeight,
    setRowHeight,
    actualHeaderHeight,
    containerStyle,
  };
};
